import PropTypes from 'prop-types';
import { IconAlertCircle, IconSparkles } from '@tabler/icons-react';

import { PROFILE_QUESTION_STATUS, getProfileQuestionStatusLabel } from './utils';

// Unanswered questions read as a hard requirement (red); answered-but-not-strong
// reads as a quality nudge (orange, matching the score bands). A finished
// question renders nothing — its green rail and score pill already say so.
const STATUS_STYLES = {
  [PROFILE_QUESTION_STATUS.missing]: { className: 'bg-red-50 text-red-600', Icon: IconAlertCircle },
  [PROFILE_QUESTION_STATUS.incomplete]: { className: 'bg-red-50 text-red-600', Icon: IconAlertCircle },
  [PROFILE_QUESTION_STATUS.ungraded]: { className: 'bg-orange-50 text-orange-600', Icon: IconSparkles },
  [PROFILE_QUESTION_STATUS.weak]: { className: 'bg-orange-50 text-orange-600', Icon: IconSparkles },
};

// Compact pill shown beside a question label stating why that question is not
// finished. Renders nothing for a finished question, or while its score is still
// being generated (ProfileFeedback shows "Evaluating…" in that case).
const ProfileQuestionStatus = ({ status, loading }) => {
  const style = STATUS_STYLES[status?.status];

  if (!style || loading) return null;

  const { className, Icon } = style;

  return (
    <span
      className={`ml-1 inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-sm font-semibold ${className}`}
    >
      <Icon size={13} />
      {getProfileQuestionStatusLabel(status)}
    </span>
  );
};

ProfileQuestionStatus.propTypes = {
  status: PropTypes.shape({
    status: PropTypes.oneOf(Object.values(PROFILE_QUESTION_STATUS)).isRequired,
    answered: PropTypes.number,
    minItems: PropTypes.number,
    score: PropTypes.number,
  }),
  // Truthy while AI feedback is being generated for this question.
  loading: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

ProfileQuestionStatus.defaultProps = {
  status: undefined,
  loading: false,
};

export default ProfileQuestionStatus;
